import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { LocalServerDto } from '../../dto/LocalServerDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteLocalServer = async (dto: LocalServerDto) => {
  const params: IApiParams = {
    url: '/localserver/deleteLocalServer.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', dto);
};
